<template>
    <kgr-child-parent-income-create-scaffold
        :pending="pending"
        :disabled="disabled"
        @primaryBtnClicked="addChildParentIncome"
        @backBtnClicked="redirectToOverview"
        @cancelBtnClicked="redirectToShow"
    >
        <kgr-child-parent-income-create-form
            :error="error"
            :child-parent-income="childParentIncome"
            @error="onFormError"
        />
    </kgr-child-parent-income-create-scaffold>
</template>

<script>
import ChildParentIncome from '../../js/dto/ChildParentIncome';
import ChildParentIncomeCreateForm from '../../components/child/child-parent-income/ChildParentIncomeCreateForm';
import ChildParentIncomeCreateScaffold from '../../components/child/child-parent-income/ChildParentIncomeCreateScaffold';
import ChildParentIncomeRepository from '../../js/repository/ChildParentIncomeRepository';
import Error from '../../js/model/Error';

export default {
    components: {
        'kgr-child-parent-income-create-scaffold': ChildParentIncomeCreateScaffold,
        'kgr-child-parent-income-create-form': ChildParentIncomeCreateForm,
    },
    props: {
        childId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            error: new Error(),
            childParentIncome: new ChildParentIncome(),
            invalidFields: 0,
            disabled: false,
        };
    },
    methods: {
        redirectToOverview() {
            window.location = '/backend/child/';
        },
        redirectToShow() {
            window.location = `/backend/child/${this.childId}/child-parent-income`;
        },
        addChildParentIncome() {
            this.pending = true;
            ChildParentIncomeRepository.create(this.childParentIncome, this.childId)
                .then(() => {
                    this.$notify.info('Die Einkommenstabelle wurde gespeichert.', {}, { saveInSession: true });
                    this.redirectToShow();
                })
                .catch((error) => {
                    this.error = error;
                    this.$notify.error('saveChanges.error');
                    this.pending = false;
                    if (this.error.status === 409) {
                        this.error.add('start', this.$t('Für dieses Datum gibt es bereits eine aktive Einkommenstabelle'));
                    }
                });
        },
        onFormError(error) {
            if (error === true) {
                this.invalidFields++;
            } else {
                this.invalidFields--;
            }
            this.disabled = this.invalidFields > 0;
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">

</style>
